import { render, staticRenderFns } from "./StateTipDialog.vue?vue&type=template&id=c9c35290&scoped=true"
import script from "./StateTipDialog.vue?vue&type=script&lang=js"
export * from "./StateTipDialog.vue?vue&type=script&lang=js"
import style0 from "./StateTipDialog.vue?vue&type=style&index=0&id=c9c35290&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9c35290",
  null
  
)

export default component.exports